export const CURSOR_LOADING_FILE_TREE = [
    {
        name: 'src',
        type: 'folder',
        open: true,
        children: [
            {
                name: 'Application',
                type: 'folder',
                open: true,
                children: [
                    {
                        name: 'Camera',
                        type: 'folder',
                        open: true,
                        children: [
                            { name: 'Camera.ts', type: 'file' },
                            { name: 'CameraKeyframes.ts', type: 'file' },
                        ],
                    },
                    {
                        name: 'UI',
                        type: 'folder',
                        open: true,
                        children: [
                            { name: 'App.tsx', type: 'file' },
                            { name: 'EventBus.ts', type: 'file' },
                            {
                                name: 'components',
                                type: 'folder',
                                open: false,
                                children: [
                                    { name: 'LoadingScreen.tsx', type: 'file' },
                                    { name: 'InterfaceUI.tsx', type: 'file' },
                                    { name: 'HelpPrompt.tsx', type: 'file' },
                                    { name: 'CodeBlock.tsx', type: 'file' },
                                    { name: 'CursorLoadingIcons.tsx', type: 'file' },
                                    { name: 'InfoOverlay.tsx', type: 'file' },
                                ],
                            },
                        ],
                    },
                    {
                        name: 'World',
                        type: 'folder',
                        open: false,
                        children: [
                            { name: 'World.ts', type: 'file' },
                            { name: 'MonitorScreen.ts', type: 'file' },
                            { name: 'deskSceneConfig.ts', type: 'file' },
                            { name: 'placeModelInScene.ts', type: 'file' },
                            { name: 'Environment.ts', type: 'file' },
                        ],
                    },
                    {
                        name: 'Utils',
                        type: 'folder',
                        open: false,
                        children: [
                            { name: 'Loading.ts', type: 'file' },
                            { name: 'Resources.ts', type: 'file' },
                            { name: 'EventEmitter.ts', type: 'file' },
                            { name: 'BakedModel.ts', type: 'file' },
                        ],
                    },
                    {
                        name: 'Shaders',
                        type: 'folder',
                        open: false,
                        children: [
                            { name: 'screen', type: 'folder', open: false, children: [{ name: 'vertex.glsl', type: 'file' }, { name: 'fragment.glsl', type: 'file' }] },
                            { name: 'organicBackground', type: 'folder', open: false, children: [{ name: 'vertex.glsl', type: 'file' }, { name: 'fragment.glsl', type: 'file' }] },
                            { name: 'gridBackground', type: 'folder', open: false, children: [{ name: 'vertex.glsl', type: 'file' }, { name: 'fragment.glsl', type: 'file' }] },
                        ],
                    },
                    {
                        name: 'Audio',
                        type: 'folder',
                        open: false,
                        children: [
                            { name: 'AudioManager.ts', type: 'file' },
                            { name: 'AudioSources.ts', type: 'file' },
                        ],
                    },
                    { name: 'Application.ts', type: 'file' },
                    { name: 'Renderer.ts', type: 'file' },
                    { name: 'sources.ts', type: 'file' },
                    { name: 'OrganicBackground.ts', type: 'file' },
                    { name: 'GridBackground.ts', type: 'file' },
                    { name: 'CoffeeSteam.ts', type: 'file' },
                ],
            },
            {
                name: 'bundler',
                type: 'folder',
                open: false,
                children: [
                    { name: 'webpack.prod.js', type: 'file' },
                    { name: 'webpack.dev.js', type: 'file' },
                ],
            },
            { name: 'script.ts', type: 'file' },
        ],
    },
    { name: 'index.html', type: 'file' },
    { name: 'style.css', type: 'file' },
    { name: 'package.json', type: 'file' },
    { name: 'tsconfig.json', type: 'file' },
    { name: '.gitignore', type: 'file' },
];
